import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Modal,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

import { useModalStyles } from "./modalStyles";
import "react-datetime/css/react-datetime.css";
import "../../../theme/custom.css";

export const ChangeNetworkEventModal = ({ open, onClose, onConfirm }) => {
  const classes = useModalStyles();

  return (
    <Modal onClose={onClose} open={open}>
      <Card className={clsx(classes.root)}>
        <CardHeader
          title="Change from Network event"
          classes={{ action: clsx(classes.closeIconAction) }}
          action={<CloseIcon onClick={onClose} />}
        />
        <Divider />
        <CardContent>
          <Typography variant="body1">
            There are one or more Network-specific filters / dynamic properties
            which will be removed if you proceed.
            <br />
            <br />
            <span className={clsx(classes.bold)}>
              Are you sure you want to change from a Network event and lose
              these filters / dynamic properties?
            </span>
          </Typography>
        </CardContent>
        <Divider />
        <CardActions className={classes.actions}>
          <Button onClick={onClose}>CANCEL</Button>
          <Button
            className={clsx(classes.deactivateButton)}
            onClick={() => {
              onConfirm();
              onClose();
            }}
            variant="contained"
          >
            CONFIRM
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};

ChangeNetworkEventModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};
